import { createMachine } from 'xstate';
import {
  type ScreenshareEvents,
  type ScreenshareStates,
} from './screenshare.types';

export const INITIAL_SCREENSHARE_STATE = 'NotStarted';

export const screenshareStateMachine = createMachine<
  unknown,
  ScreenshareEvents,
  { value: ScreenshareStates; context: never }
>({
  /** @xstate-layout N4IgpgJg5mDOIC5SwMYCcxgHawBYEMMA6AOQHsAXAZQsIsgGIBJEpgFSYEEAZJgLQCiAbQAMAXUSgADmVgBLCnLJZJIAB6IATCICMRAMybNATh2b9IgGwAWTToCs+gDQgAnolsiiO-fesjjAHZrU0sTAF9wl1QMbDxCMFJKGjpGFnYAfQAxTiZuAQARUQkkEBl5RWVVDQQ7PUMTMwsbO0cXdwQfLwAOI1NNe0C-HUtDSOj0TBwCYnJqWjR6CAYqARICjKoAYQAlATWqAAlOPYy9gEUAVQEqNmLVcoUlFVKanW76vqarWwdnN0QgR0XkClnslgc1kGvU0lnGIBiU3is2SCyWDD2WwETAAaoVNrt9iQjicBGcBFcbndxA9ZE8qq9EDpTAYvuYfq1-h17PYvCN-H4PjpIZp4Yi4jNEltcGQ6VgoAB1ORYCBkADubDIVElKzYJw4JAA4ps2HtOABZe6lR6VF6gGphdpMwz6Ay+YzmYWWboibr6MWTCUJIgK-BPeVZMhoHZgACOAFc4BQY7AZDgwBiBAApARbNgEvYHY6nC7XW5W6R023VLSgohBazWSymEQ-QZOhCBYz2IiWX2WQK+L2aazdAOxabB0PhqCR6NxxOwZNwNOwDOcLZYgAK+e2heJxbJpapFbKVeeNYQ9k0HZ8HyIvR5Iihlm9rdFUQRgcnxGnigjUYxgmSYpquGZbJwJBYtwBZEiSJYUmW1IlJWFQXoytQsoEIj6GEdhhKMwodt01iuh8Pq-P4sL6Do45IpKRBAYuy4oGAcgAG6MBu267oSRakuSlLljS1rngy9oeJo3T1gO+jWIOxj+MC1gdvJPT6B6sI6F2JF9tYdFBsQTEgWArEcYwew5nmsH8QhQnIbSaHieoiAWNY9YjvJ2m+PY2mWB2BEyQ4gT4a+Nj6Z+4o-okxlLjGZmccsEFQQIMF7nBh6CUhp42uhEm1A4BjDEM7z6LhUlcogYUPtpmhDEYfgWMYBnRYxC4mQlaSsBwPD8MIImofSdouQgimaEQIX6IEQIiNoPIqQCtRAgY8m+d2Po0RC9gtciMXtXFYAAFameiqzrDZB4CcewkoWeTnDdyxiWPWcndN0XZNc+-xvHJ40joORghcYVgQjtDHcGQ+AQMqUA0Bg+AALYMNwADynAFCwxq3Ga5oZAUKMkP1t25c5Dp+EQjaBG9cm+sCU23m5RABMKLqmB8Rhg8GTBYFuaBkFAGCwLAuoo1uF3wUTjlDZeIW3j4rqgr07zdMYhhBIEkSflgZAQHAqhRbtUvVhhAC0vheNR5jBMYxh+vYxgdib5j1jbNsmIYfo+n6nMovMqQQEbeUjWbs1EJbU0hLb7odhpPYiNeULBCIQytvJPtSjKcqKsqqoalqkqB6TVVyRTvhU7VqsaZVS16K2KuKVXU24dtkXfrtRACGgfNoIXw01HJegek9oK+m9fyBAFroNKYiubWEzWtxO7ed93RDc08+AADZyAAXvgtor1GveXvoKsecPfZvR8jgT4tDheDY9i9L0NvaSD6chmG-6zoB+3Lqmyg1zHwwgpCaKdwQ2BViEauM0KZ1QCLNbCb1Zof1iixNiiVgH5T8F4EIydrxA08tXPwxgHwDDwcCa871-SL3osGNBMZjooCWFgkawJXysikjfOSHoeQdnts9VWo53qqwQaRVBf8tj4CwKxTem9ICsLeDoJsRBeTTV6AOEcHwFodGCO5eWOFXwpxMGOWhhlEgQyhjDOGYBEaKNcuCCavoLB+l8F7auTRnraSbL4UYzjcIf0sdDeUNjEZECCTDCGKAt6hIRvYhA-h3JIJcWVJ+ziGbOxCIOXozMLCOECZDYJsMKDwwRuEwpMMYwI0oGAWJ8TElOL9P4tJfoGb3lts2UYwwTDTQ-tzXm-NBbwFEvdS8wN3KnzqthQYNs8ly1sEzYUdV5KgjMN6TW4QgA */
  id: 'screenshare',
  initial: INITIAL_SCREENSHARE_STATE,
  predictableActionArguments: true,
  preserveActionOrder: true,

  states: {
    NotStarted: {
      on: {
        INITIALIZE: {
          target: 'ChoosingWindowToShare',
        },
        INIT_FAILED: {
          target: 'Error',
        },
        SEND_SCREENSHARE_REQUEST: {
          target: 'WaitingForRequestResponse',
        },
        RECEIVED_SCREENSHARE_REQUEST: {
          target: 'RequestReceived',
        },
      },
    },
    ChoosingWindowToShare: {
      on: {
        STARTING_STREAM: {
          target: 'InProgress',
        },
        PERMISSIONS_ERROR: {
          target: 'NotStarted',
        },
        ACCEPT_SCREENSHARE_REQUEST: {
          // Patient can close the browser-dialog for screenshare and then re-open it
        },
        CANCEL_SCREENSHARE_REQUEST: {
          target: 'NotStarted',
        },
      },
    },
    Error: {
      initial: 'InitializationError',
      states: {
        InitializationError: {},
        PermissionsError: {},
      },
    },
    WaitingForRequestResponse: {
      on: {
        REJECT_SCREENSHARE_REQUEST: {
          target: 'RequestRejected',
        },
        ACCEPT_SCREENSHARE_REQUEST: {
          target: 'LoadingStream.LoadingRemoteStream',
        },
        CANCEL_SCREENSHARE_REQUEST: {
          target: 'NotStarted',
        },
      },
    },
    RequestReceived: {
      on: {
        ACCEPT_SCREENSHARE_REQUEST: {
          target: 'ChoosingWindowToShare',
        },
        REJECT_SCREENSHARE_REQUEST: {
          target: 'NotStarted',
        },
        CANCEL_SCREENSHARE_REQUEST: {
          target: 'NotStarted',
        },
        INITIALIZE: {
          target: 'ChoosingWindowToShare',
        },
      },
    },
    RequestRejected: {
      on: {
        SEND_SCREENSHARE_REQUEST: {
          target: 'WaitingForRequestResponse',
        },
        CANCEL_SCREENSHARE_REQUEST: {
          target: 'NotStarted',
        },
      },
    },
    RequestCancelled: {
      type: 'final',
    },
    LoadingStream: {
      initial: 'LoadingLocalStream',
      states: {
        LoadingLocalStream: {},
        LoadingRemoteStream: {
          on: {
            STOP_SCREENSHARE: {
              target: '#screenshare.RequestRejected',
            },
          },
        },
      },
      on: {
        LOADING_STREAM_DONE: {
          target: 'InProgress',
        },
        // Permissions error from the patient can only trigger at this point
        REJECT_SCREENSHARE_REQUEST: {
          target: 'RequestRejected',
        },
        CANCEL_SCREENSHARE_REQUEST: {
          target: 'NotStarted',
        },
      },
    },
    InProgress: {
      on: {
        STOP_SCREENSHARE: {
          target: 'NotStarted',
        },
      },
    },
  },
});
